<template>
    <div class="activity-description-page">
        <breadcrumbs class="pb-3" :text="productName" />
        <v-row>
            <v-col cols="12" md="12">
                <div class="d-flex align-center">
                    <h1 class="me-2">{{ productName }}</h1>
                </div>
            </v-col>
        </v-row>
        <v-tabs v-model="productTab" color="primary">
            <v-tab :value="'tab-information'">{{ $t('information') }}</v-tab>
            <v-tab :value="'tab-description'">{{ $t('description') }}</v-tab>
            <v-tab :value="'tab-photo'">{{ $t('photo') }}</v-tab>
        </v-tabs>
        <v-tabs-window v-model="productTab">
            <v-tabs-window-item value="tab-information">
                <InfoDescriptionExcursionForm
                    :excursion-info="excursionInfo"
                    :loading="isExcursionInfoLoading"
                    @updated="loadExcursionInfo"
                />
            </v-tabs-window-item>
            <v-tabs-window-item value="tab-description">
                <ExcursionDetailsDescriptionForm
                    :excursion-info="excursionInfo"
                    :loading="isExcursionInfoLoading"
                    @updated="loadExcursionInfo"
                />
            </v-tabs-window-item>
            <v-tabs-window-item value="tab-photo">
                <ExcursionPhotosDescriptionForm
                    :excursion-info="excursionInfo"
                    :loading="isExcursionInfoLoading"
                    @updated="loadExcursionInfo"
                />
            </v-tabs-window-item>
        </v-tabs-window>
    </div>
</template>

<script setup lang="ts">
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'
    import InfoDescriptionExcursionForm from '~/components/products/activities/InfoDescriptionExcursionForm.vue'
    import {appInstance} from '~/utils/app-accessor'
    import type {Ref} from 'vue'
    import ExcursionDetailsDescriptionForm from '~/components/products/activities/ExcursionDetailsDescriptionForm.vue'
    import ExcursionPhotosDescriptionForm from '~/components/products/activities/ExcursionPhotosDescriptionForm.vue'

    const excursionInfo = ref(null)
    const isExcursionInfoLoading: Ref<boolean> = ref(false)
    const productTab = ref(null)

    const {params} = useRoute()
    const {t} = useI18n()

    onMounted(async () => {
        await loadExcursionInfo()
    })

    const loadExcursionInfo = async () => {
        if (params.activityId) {
            try {
                isExcursionInfoLoading.value = true
                const rs = await appInstance.$api.excursions.get({
                    id: params.activityId,
                    locale: 'all',
                })

                excursionInfo.value = rs.excursions[0]
            } catch (e) {
                excursionInfo.value = {}
            } finally {
                isExcursionInfoLoading.value = false
            }
        }
    }

    const getName = (name): string => {
        if (!name) return ''
        if (name.en) return name.en
        const firstAvailableKey = Object.keys(name)[0]
        return name[firstAvailableKey]
    }

    const productName = computed(() => {
        return excursionInfo.value?.name ? getName(excursionInfo.value.name) : `${t('serviceType.ACTIVITY')}`
    })
</script>
